import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-446c4588")

_pushScopeId("data-v-446c4588")
const _hoisted_1 = { class: "recordList" }
const _hoisted_2 = { class: "record-body pt32" }
const _hoisted_3 = { class: "li mb8" }
const _hoisted_4 = { class: "title mb4" }
const _hoisted_5 = { class: "msg word-wrap-break-word" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ui_title_vue = _resolveComponent("ui-title-vue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ui_title_vue, {
      class: "mb32",
      title: "实验记录",
      hasShow: false
    }, {
      body: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (v) => {
            return (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, _toDisplayString(v.time), 1),
              _createVNode("div", _hoisted_5, _toDisplayString(v.msg), 1)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    })
  ]))
})